import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/photo.png';
import _imports_1 from '@/assets/images/model-img3.png';
import _imports_2 from '@/assets/images/model-img4.png';
import _imports_3 from '@/assets/images/loading.png';
const _withScopeId = n => (_pushScopeId("data-v-1d6f02e5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "illustrate"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin": "0 auto"
  }
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 2,
  class: "el-upload__text"
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_6 = {
  class: "tip"
};
const _hoisted_7 = {
  class: "main-content"
};
const _hoisted_8 = {
  class: "introduce-list"
};
const _hoisted_9 = {
  class: "introduce-item"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_11 = {
  class: "info rightTextShow"
};
const _hoisted_12 = {
  class: "title"
};
const _hoisted_13 = {
  class: "titleSecond"
};
const _hoisted_14 = {
  class: "titleThird"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://dl.designresearchsociety.org/drs-conference-papers/drs2022/researchpapers/296/",
  style: {
    "background-image": "none",
    "background": "no-repeat center right",
    "padding-right": "0px",
    "font-size": "18px",
    "text-decoration": "none",
    "font-weight": "bold",
    "color": "#006FFF"
  }
}, "DRS", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://dl.acm.org/doi/10.1145/3503161.3548433",
  style: {
    "background-image": "none",
    "background": "no-repeat center right",
    "padding-right": "0px",
    "font-size": "18px",
    "text-decoration": "none",
    "font-weight": "bold",
    "color": "#006FFF"
  }
}, "Multimedia", -1));
const _hoisted_17 = {
  style: {
    "text-align": "right"
  }
};
const _hoisted_18 = {
  class: "introduce-item"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_20 = {
  class: "info rightTextShow"
};
const _hoisted_21 = {
  class: "title"
};
const _hoisted_22 = {
  class: "titleSecond"
};
const _hoisted_23 = {
  class: "titleThird"
};
const _hoisted_24 = {
  href: "https://doi.org/10.1145/3543507.3583489",
  style: {
    "background-image": "none",
    "background": "no-repeat center right",
    "padding-right": "0px",
    "font-size": "18px",
    "text-decoration": "none",
    "font-weight": "bold",
    "color": "#006FFF"
  }
};
const _hoisted_25 = {
  href: "https://ieeexplore.ieee.org/document/10184464",
  style: {
    "background-image": "none",
    "background": "no-repeat center right",
    "padding-right": "0px",
    "font-size": "18px",
    "text-decoration": "none",
    "font-weight": "bold",
    "color": "#006FFF"
  }
};
const _hoisted_26 = {
  class: "image-info-warp"
};
const _hoisted_27 = {
  class: "image-box"
};
const _hoisted_28 = ["src"];
const _hoisted_29 = {
  class: "image-info"
};
const _hoisted_30 = {
  class: "image-tag"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "loading-img",
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_32 = {
  class: "image-size"
};
const _hoisted_33 = {
  class: "link"
};
const _hoisted_34 = {
  class: "link"
};
const _hoisted_35 = {
  class: "retrieve-result"
};
const _hoisted_36 = {
  key: 0,
  class: "loading-placeholder"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "loading-img",
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_38 = {
  class: "minutes"
};
const _hoisted_39 = {
  class: "minutes"
};
const _hoisted_40 = {
  key: 1,
  class: "result-list"
};
const _hoisted_41 = ["onClick"];
const _hoisted_42 = {
  class: "result-item"
};
const _hoisted_43 = ["src"];
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon"
}, null, -1));
const _hoisted_45 = {
  class: "comparison-warp"
};
const _hoisted_46 = {
  class: "tab-content mode1"
};
const _hoisted_47 = {
  class: "left"
};
const _hoisted_48 = {
  class: "img-box"
};
const _hoisted_49 = ["src"];
const _hoisted_50 = {
  key: 1,
  style: {
    "object-fit": "contain"
  },
  src: _imports_0,
  alt: ""
};
const _hoisted_51 = {
  class: "right"
};
const _hoisted_52 = {
  class: "img-box"
};
const _hoisted_53 = ["src"];
const _hoisted_54 = {
  key: 1,
  style: {
    "object-fit": "contain"
  },
  src: _imports_0,
  alt: ""
};
const _hoisted_55 = {
  class: "tab-content mode2"
};
const _hoisted_56 = {
  class: "img-box"
};
const _hoisted_57 = ["src"];
const _hoisted_58 = ["src"];
const _hoisted_59 = {
  class: "toggle-btn"
};
const _hoisted_60 = {
  class: "pagination"
};
import SearchDescription from '@/components/SearchDescription';
import { Close } from '@element-plus/icons-vue';
import { ref, computed } from 'vue';
import { genFileId, ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/css';
import { useRouter } from 'vue-router';
import axios from 'axios';
import request from '@/utils/request.js';
import i18n from '@/language/index';
export default {
  __name: 'CopyrightProtection',
  setup(__props) {
    // import Header from '@/components/Header'
    // import PageFooter from '@/components/PageFooter'
    const isRetrieval = ref(true);
    const backgroundColor = ref('');
    const router = useRouter();
    const uploadPopover = ref();
    const uploadRef = ref();
    const uploadInputUrl = ref(); // 输入的图片url
    const imgPreviewUrl = ref(''); // 预览图url
    const currentFile = ref(null); // 当前上传的文件
    const isStartUpload = ref(false); // 是否已点击检索抄袭
    const imgSize = ref(''); // 上传的图片的尺寸
    const uploadType = ref(''); // 上传的是文件还是提交url
    const loading = ref(false); // 是否计算中

    const currentPage = ref(1);
    const resultList = ref([]);
    const tagFilterList = computed(() => {
      return resultList.value.filter(item => !checkTagVal.value || item.class.includes(checkTagVal.value));
    });

    // 检索案例按钮
    const handleRetrieval = () => {
      isRetrieval.value = !isRetrieval.value;
      backgroundColor.value = '#006FFF';
    };
    const goBack = () => {
      isRetrieval.value = !isRetrieval.value;
      backgroundColor.value = '';
    };

    // 本地分页后的数据
    const dataList = computed(() => {
      // 展示当前页面数据
      const m = (currentPage.value - 1) * 12;
      const n = currentPage.value * 12;
      return tagFilterList.value.slice(m, n);
    });

    // 预计时间
    const progressTime = computed(() => {
      return timing.value >= 60 ? 1 : 2;
    });

    // 图片标签点击后的值
    const checkTagVal = ref('');
    function checkTag(val) {
      checkTagVal.value = val;
    }

    // 拖拽上传组件触发
    function uploadChange(uploadFile, uploadFiles) {
      var _uploadFile$raw;
      if (uploadFile.status === 'ready' && !(uploadFile !== null && uploadFile !== void 0 && (_uploadFile$raw = uploadFile.raw) !== null && _uploadFile$raw !== void 0 && _uploadFile$raw.oldFile)) {
        uploadType.value = 'file';
        currentFile.value = uploadFile.raw;
        // 获取图片的尺寸信息
        const url = window.URL || window.webkitURL;
        const img = new Image();
        img.src = url.createObjectURL(uploadFile.raw);
        img.onload = () => {
          imgSize.value = `${img.width} x ${img.height}px`;
        };
        imgPreviewUrl.value = url.createObjectURL(uploadFile.raw);
        submitUpload();
        uploadPopover.value.hide();
      }
    }

    // url输入框改变触发
    function uploadUrlChange() {
      uploadType.value = 'url';
    }

    // 上传弹窗内右下角上传文件按钮触发
    function uploadChange1(uploadFile, uploadFiles) {
      uploadRef.value.clearFiles();
      const file = uploadFile.raw;
      file.uid = genFileId();
      uploadRef.value.handleStart(file);
    }
    function handleExceed(files) {
      uploadRef.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadRef.value.handleStart(file);
    }
    let returnImgUrl; // 后台把url解析成图片并返回的url

    // 手动提交上传
    function submitUpload() {
      (uploadType.value === 'file' || uploadType.value === 'url') && setTimeout(() => {
        isStartUpload.value = true;
        targetClasses.value = [];
        resultList.value = [];
      }, 200);
      if (uploadType.value === 'file') {
        // 上传的是图片文件时
        uploadRef.value.submit();
        loading.value = true;
        startTiming();
      } else if (uploadType.value === 'url') {
        // 提交的是输入的url时
        imgPreviewUrl.value = '';
        returnImgUrl = '';
        imgSize.value = '';
        request.post('/upload_url', {
          img_url: uploadInputUrl.value
        }).then(res => {
          imgPreviewUrl.value = 'https://design.didalab.cn:8002' + res.data.url; // 后台把url解析成图片并返回图片url
          returnImgUrl = res.data.url;
          imgSize.value = `${res.data.shape[1]} x ${res.data.shape[0]}px`;
          loading.value = true;
          uploadUrl();
        }).catch(err => {
          if (err.code === '400') {
            ElMessage.error(err.message);
          }
        });
      }
    }

    // 上传组件上传文件成功回调
    function uploadSuccess(res) {
      if (res.code === '200') {
        loading.value = false;
        processResult(res.data);
        timing.value = 0;
        clearInterval(time);
        uploadRef.value.clearFiles();
        const file = currentFile.value;
        file.oldFile = true;
        file.uid = genFileId();
        uploadRef.value.handleStart(file);
      }
    }
    const CancelToken = axios.CancelToken;
    let source = CancelToken.source();

    // 上传后台返回的url检索图片
    function uploadUrl() {
      startTiming();
      const fd = new FormData();
      fd.append('img_url', returnImgUrl);
      axios.post('https://design.didalab.cn:8002/upload_image', fd, {
        cancelToken: source.token,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(({
        data
      }) => {
        loading.value = false;
        timing.value = 0;
        clearInterval(time);
        processResult(data.data);
      }).then(err => {
        console.error(err);
      });
    }
    const targetImagePath = ref(null);
    const targetImageArea = ref(null);
    const targetClasses = ref([]);
    function processResult(data) {
      const simImages = data.sim_images || [];
      resultList.value = simImages.map(i => {
        i.imgUrl = 'https://design.didalab.cn:8002/image/' + i.image_path.slice(i.image_path.indexOf('\\') + 1);
        i.similarity = JSON.stringify(i.sim * 100).substring(0, 5);
        return i;
      });
      targetImagePath.value = data.target_image.image_path;
      targetImageArea.value = data.target_image.tgt_area;
      targetClasses.value = Array.from(new Set(data.target_image.classes));
      checkTagVal.value = targetClasses.value.length === 1 ? targetClasses.value[0] : '';
    }

    // 开始计时
    let time = null;
    const timing = ref(0); // 计算时间
    function startTiming() {
      time && clearInterval(time);
      timing.value = 0;
      time = setInterval(() => {
        timing.value += 1;
      }, 1000);
    }
    function handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;
      if (!items || items.length === 0) {
        ElMessage.error('当前浏览器不支持本地');
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile();
          break;
        }
      }
      if (!file) {
        ElMessage.error('粘贴内容非图片');
        return;
      }
      // 此时file就是我们的剪切板中的图片对象
      // 如果需要预览，可以执行下面代码
      const reader = new FileReader();
      reader.readAsDataURL(file);
      uploadRef.value.clearFiles();
      file.uid = genFileId();
      uploadRef.value.handleStart(file);
    }

    // 刷新按钮
    function refresh() {
      if (uploadType.value === 'file') {
        uploadRef.value.abort();
        uploadRef.value.clearFiles();
        const file = currentFile.value;
        file.uid = genFileId();
        uploadRef.value.handleStart(file);
        submitUpload();
      } else {
        loading.value = true;
        source.cancel();
        source = CancelToken.source();
        uploadUrl();
      }
    }
    const triggerPopover = () => {
      document.getElementById('hidden__button').click();
    };

    /** popover的ref集合 */
    const popoverRefs = {};

    /** 设置popover的ref */
    function setPopoverRef(el, index) {
      popoverRefs['item' + index] = el;
    }

    /** 隐藏弹层 */
    function hidePopover(index) {
      popoverRefs['item' + index].hide();
    }

    // 点击结果显示对比
    function showComparison(item) {
      if (item.target_img && item.lib_img) {
        return;
      }
      request.post('/get_contrast_image', {
        target_img_path: targetImagePath.value,
        target_img_area: JSON.parse(targetImageArea.value),
        target_img_classes: targetClasses.value,
        lib_img_path: item.image_path.replace('\\', '/'),
        lib_img_area: item.tgt_area,
        lib_img_classes: item.class
      }).then(res => {
        item.target_img = 'data:image/jpeg;base64,' + res.data.target_img_byte;
        item.lib_img = 'data:image/jpeg;base64,' + res.data.lib_img_byte;
      });
    }

    // 计算弹出层位置
    function calculatePlacement(index) {
      return index >= 4 * (Math.ceil(12 / 4) - 1) ? 'top' : 'bottom';
    }
    const comparisonTab = ref(1);
    function comparisonTabChange(val) {
      comparisonTab.value = val;
    }
    const viewType = ref(2);
    function toggleView(val) {
      viewType.value = val;
    }
    function backTop() {
      document.documentElement.scrollTop = 0;
    }
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_check_tag = _resolveComponent("el-check-tag");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("div", {
        class: _normalizeClass(["upload-bg", {
          'small': isStartUpload.value
        }])
      }, [_withDirectives(_createElementVNode("h2", null, _toDisplayString(_ctx.$t('protection.originality')), 513), [[_vShow, !isStartUpload.value]]), _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('protection.explain')), 1), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
        class: _normalizeClass(["reference-button", _unref(i18n).global.locale.value === 'en' ? 'inputWidth' : '']),
        size: "large",
        onChange: uploadUrlChange,
        modelValue: uploadInputUrl.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => uploadInputUrl.value = $event),
        placeholder: _ctx.$t('protection.placeholderUrl')
      }, {
        suffix: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "el-input__icon",
          onClick: triggerPopover
        })]),
        _: 1
      }, 8, ["modelValue", "placeholder", "class"]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        size: "large",
        onClick: submitUpload,
        class: _normalizeClass(_unref(i18n).global.locale.value === 'en' ? 'buttonWidth' : '')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('protection.copyButton')), 1)]),
        _: 1
      }, 8, ["class"])), [[_directive_loading, loading.value]]), _createVNode(_component_el_popover, {
        ref_key: "uploadPopover",
        ref: uploadPopover,
        "popper-class": "uploadPopper",
        placement: "bottom-end",
        width: "3.44rem",
        "show-arrow": false,
        trigger: "click"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_button, {
          id: "hidden__button",
          style: {
            "width": "0px",
            "margin": "0px",
            "border": "0px"
          }
        })]),
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          ref_key: "uploadRef",
          ref: uploadRef,
          class: "upload-box",
          drag: "",
          action: "https://design.didalab.cn:8002/upload_image",
          "show-file-list": false,
          limit: 1,
          name: "file",
          accept: "image/*",
          "on-exceed": handleExceed,
          "auto-upload": false,
          "on-change": uploadChange,
          "on-success": uploadSuccess
        }, {
          default: _withCtx(() => [imgPreviewUrl.value ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: imgPreviewUrl.value,
            alt: "",
            style: {
              "height": "251px",
              "object-fit": "contain"
            },
            onPaste: handlePaste
          }, null, 40, _hoisted_3)) : _createCommentVNode("", true), !imgPreviewUrl.value ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "upload-img",
            src: _imports_0,
            alt: "",
            onPaste: handlePaste
          }, null, 32)) : _createCommentVNode("", true), !imgPreviewUrl.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('protection.drag')), 1)) : _createCommentVNode("", true)]),
          _: 1
        }, 512), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_upload, {
          limit: 1,
          "show-file-list": false,
          accept: "image/*",
          "auto-upload": false,
          "on-change": uploadChange1,
          "on-exceed": handleExceed
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "upload-button",
            size: "large",
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('protection.localUpload')), 1)]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }, 512)]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("span", {
        onClick: handleRetrieval
      }, _toDisplayString(_ctx.$t('protection.use')), 513), [[_vShow, !isStartUpload.value]])])], 2), _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_Transition, {
        appear: "",
        mode: "out-in",
        name: "animate__animated animate__bounce",
        "enter-active-class": "animate__animated animate__InLeft",
        "leave-active-class": "animate__animated animate__fadeOut"
      }, {
        default: _withCtx(() => [_hoisted_10]),
        _: 1
      }), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('protection.retrieval')), 1), _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('protection.retrievalImage')), 1), _createElementVNode("p", _hoisted_14, [_createTextVNode(_toDisplayString(_ctx.$t('protection.text')) + " ", 1), _hoisted_15, _createTextVNode(" " + _toDisplayString(_ctx.$t('protection.text1')) + " ", 1), _hoisted_16, _createTextVNode(" " + _toDisplayString(_ctx.$t('protection.text2')), 1)])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("a", {
        href: "javascript:void(0)",
        onClick: backTop
      }, _toDisplayString(_ctx.$t('protection.tryNow')), 1)])])]), _createElementVNode("div", _hoisted_18, [_createVNode(_Transition, {
        appear: "",
        mode: "out-in",
        name: "animate__animated animate__bounce",
        "enter-active-class": "animate__animated animate__InLeft",
        "leave-active-class": "animate__animated animate__fadeOut"
      }, {
        default: _withCtx(() => [_hoisted_19]),
        _: 1
      }), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('protection.watermark')), 1), _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('protection.artwork')), 1), _createElementVNode("p", _hoisted_23, [_createTextVNode(_toDisplayString(_ctx.$t('protection.longText')) + " ", 1), _createElementVNode("a", _hoisted_24, _toDisplayString(_ctx.$t('protection.markText1')), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t('protection.markText2')), 1), _createElementVNode("a", _hoisted_25, _toDisplayString(_ctx.$t('protection.markText3')), 1), _createTextVNode(_toDisplayString(_ctx.$t('protection.markText4')), 1)])]), _createElementVNode("div", {
        style: {
          "text-align": "right"
        },
        onClick: _cache[1] || (_cache[1] = $event => _unref(router).push('/ComingSoon'))
      }, [_createVNode(_component_router_link, {
        to: "/ComingSoon"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('protection.tryNow')), 1)]),
        _: 1
      })])])])], 512), [[_vShow, !isStartUpload.value]]), _withDirectives(_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("img", {
        src: imgPreviewUrl.value,
        alt: ""
      }, null, 8, _hoisted_28)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('protection.probably')), 1), _createElementVNode("div", _hoisted_30, [loading.value ? (_openBlock(), _createBlock(_component_el_check_tag, {
        key: 0,
        class: "loading-tag"
      }, {
        default: _withCtx(() => [_hoisted_31]),
        _: 1
      })) : _createCommentVNode("", true), !loading.value && !targetClasses.value.length ? (_openBlock(), _createBlock(_component_el_check_tag, {
        key: 1
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('protection.noSimilar')), 1)]),
        _: 1
      })) : _createCommentVNode("", true), !loading.value && targetClasses.value.length >= 2 ? (_openBlock(), _createBlock(_component_el_check_tag, {
        key: 2,
        checked: checkTagVal.value === '',
        onClick: _cache[2] || (_cache[2] = $event => checkTag(''))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('protection.all')), 1)]),
        _: 1
      }, 8, ["checked"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(targetClasses.value, item => {
        return _openBlock(), _createBlock(_component_el_check_tag, {
          key: item,
          checked: checkTagVal.value === item,
          onClick: $event => checkTag(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item === '龙' ? _ctx.$t('protection.dragon') : item === '老虎' ? _ctx.$t('protection.tiger') : item === '人物' ? _ctx.$t('protection.person') : item === '仙鹤' ? _ctx.$t('protection.crane') : item === '锦鲤' ? _ctx.$t('protection.carp') : item === '山' ? _ctx.$t('protection.mountain') : item === '鹿' ? _ctx.$t('protection.deer') : item === '古代建筑' ? _ctx.$t('protection.ancient') : item === '荷花' ? _ctx.$t('protection.lotus') : ''), 1)]),
          _: 2
        }, 1032, ["checked", "onClick"]);
      }), 128))]), _createElementVNode("h3", null, _toDisplayString(_ctx.$t('protection.ImageInformation')), 1), _createElementVNode("div", _hoisted_32, _toDisplayString(imgSize.value), 1), _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t('protection.detect')), 1), _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('protection.plagiarism')), 1)])], 512), [[_vShow, isStartUpload.value]]), _withDirectives(_createElementVNode("div", _hoisted_35, [_withDirectives(_createElementVNode("h3", null, _toDisplayString(_ctx.$t('protection.pictures')), 513), [[_vShow, resultList.value.length]]), _withDirectives(_createElementVNode("p", {
        style: {
          "color": "#A0A0A0"
        }
      }, _toDisplayString(_ctx.$t('protection.click')), 513), [[_vShow, resultList.value.length]]), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_hoisted_37, _createElementVNode("p", null, [_createTextVNode(_toDisplayString(_ctx.$t('protection.loading')) + "......" + _toDisplayString(_ctx.$t('protection.please')), 1), _createElementVNode("span", _hoisted_38, _toDisplayString(progressTime.value), 1), _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('protection.minutes')), 1)]), _withDirectives(_createElementVNode("div", {
        class: "wait"
      }, _toDisplayString(_ctx.$t('protection.long')), 513), [[_vShow, timing.value >= 180]]), _withDirectives(_createVNode(_component_el_button, {
        size: "large",
        type: "primary",
        onClick: refresh
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('noFind.agian')), 1)]),
        _: 1
      }, 512), [[_vShow, timing.value >= 180]])])) : (_openBlock(), _createElementBlock("div", _hoisted_40, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item, index) => {
        return _openBlock(), _createBlock(_component_el_popover, {
          "popper-class": "retrieveResultPopper",
          key: item.imgUrl,
          ref_for: true,
          ref: el => {
            setPopoverRef(el, index);
          },
          placement: calculatePlacement(index),
          width: "2.3835rem",
          offset: -50,
          "show-arrow": false,
          trigger: "click"
        }, {
          reference: _withCtx(() => [_createElementVNode("div", {
            class: "col",
            onClick: $event => showComparison(item)
          }, [_createElementVNode("div", _hoisted_42, [_createElementVNode("img", {
            src: item.imgUrl,
            alt: ""
          }, null, 8, _hoisted_43), _hoisted_44]), _createElementVNode("h4", {
            style: _normalizeStyle({
              color: item.similarity >= 70 ? '#FF0000' : '#333333'
            })
          }, _toDisplayString(_ctx.$t('protection.similarity')) + "：" + _toDisplayString(item.similarity) + "%", 5)], 8, _hoisted_41)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_45, [_createVNode(_component_el_icon, {
            class: "close-btn",
            onClick: $event => hidePopover(index)
          }, {
            default: _withCtx(() => [_createVNode(_unref(Close))]),
            _: 2
          }, 1032, ["onClick"]), _createElementVNode("div", {
            class: _normalizeClass(_unref(i18n).global.locale.value === 'en' ? 'tabNew' : 'tabs-nav')
          }, [_createVNode(_component_el_check_tag, {
            checked: comparisonTab.value === 1,
            onClick: _cache[3] || (_cache[3] = $event => comparisonTabChange(1))
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('protection.SimilarContent')), 1)]),
            _: 1
          }, 8, ["checked"]), _createVNode(_component_el_check_tag, {
            checked: comparisonTab.value === 2,
            onClick: _cache[4] || (_cache[4] = $event => comparisonTabChange(2))
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('protection.compare')), 1)]),
            _: 1
          }, 8, ["checked"])], 2), _withDirectives(_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [item.lib_img ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: item.lib_img,
            alt: ""
          }, null, 8, _hoisted_49)) : (_openBlock(), _createElementBlock("img", _hoisted_50))]), _createElementVNode("p", null, _toDisplayString(_ctx.$t('protection.SearchResult')), 1)]), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [item.target_img ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: item.target_img,
            alt: ""
          }, null, 8, _hoisted_53)) : (_openBlock(), _createElementBlock("img", _hoisted_54))]), _createElementVNode("p", null, _toDisplayString(_ctx.$t('protection.queryImage')), 1)])], 512), [[_vShow, comparisonTab.value === 1]]), _withDirectives(_createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createElementVNode("img", {
            class: "img1",
            src: imgPreviewUrl.value,
            alt: ""
          }, null, 8, _hoisted_57), _createElementVNode("img", {
            class: "img2",
            style: _normalizeStyle([{
              "z-index": "2"
            }, {
              opacity: viewType.value === 1 ? 1 : viewType.value === 2 ? .5 : 0
            }]),
            src: item.imgUrl,
            alt: ""
          }, null, 12, _hoisted_58)]), _createElementVNode("div", _hoisted_59, [_createElementVNode("button", {
            class: _normalizeClass({
              active: viewType.value === 1
            }),
            type: "button",
            onMouseout: _cache[5] || (_cache[5] = $event => viewType.value = 2),
            onMousemove: _cache[6] || (_cache[6] = $event => toggleView(1))
          }, _toDisplayString(_ctx.$t('protection.SearchResult')), 35), _createElementVNode("button", {
            class: _normalizeClass({
              active: viewType.value === 2
            }),
            type: "button"
          }, _toDisplayString(_ctx.$t('protection.result')), 3), _createElementVNode("button", {
            class: _normalizeClass({
              active: viewType.value === 3
            }),
            type: "button",
            onMouseout: _cache[7] || (_cache[7] = $event => viewType.value = 2),
            onMousemove: _cache[8] || (_cache[8] = $event => toggleView(3))
          }, _toDisplayString(_ctx.$t('protection.queryImage')), 35)])], 512), [[_vShow, comparisonTab.value === 2]])])]),
          _: 2
        }, 1032, ["placement"]);
      }), 128))])), _createElementVNode("div", _hoisted_60, [_createVNode(_component_el_pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[9] || (_cache[9] = $event => currentPage.value = $event),
        layout: "prev, pager, next",
        "hide-on-single-page": "",
        "page-size": 12,
        style: {
          "margin-bottom": "10px"
        },
        total: tagFilterList.value.length
      }, null, 8, ["current-page", "total"])])], 512), [[_vShow, isStartUpload.value]])])], 512), [[_vShow, isRetrieval.value]]), _withDirectives(_createVNode(_unref(SearchDescription), {
        onGoBack: goBack
      }, null, 512), [[_vShow, !isRetrieval.value]])], 64);
    };
  }
};